import React from 'react';
import PropTypes from 'prop-types';
import Modal from '@material-ui/core/Modal';
import { makeStyles } from '@material-ui/core/styles';
import { Fade, CircularProgress } from '@material-ui/core';
import WarningIcon from '@material-ui/icons/Warning';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import InfoIcon from '@material-ui/icons/Info';
import { colors, fontSize } from '../../constants/styleConstants';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    width: 500,
    maxWidth: '90%',
    padding: 28,
    maxHeight: '95vh',
    borderRadius: 4,
    backgroundColor: colors.white,
    textAlign: 'center',
    '&:focus': {
      outline: 'none',
    },
  },
  icon: {
    height: 48,
    width: 48,
  },
  title: {
    fontSize: fontSize.h3,
    marginBottom: '1rem',
    marginTop: '1.3rem',
    wordBreak: 'break-word',
  },
  severalButtonsBox: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
  },
  buttonsBlock: {
    display: 'flex',
    justifyContent: 'space-around',
    width: '100%',
    marginTop: 25,
  },
}));

const ActionStatusModal = ({ children, isOpened, type, onClose, buttons, title }) => {
  const classes = useStyles();

  return (
    <Modal open={isOpened} className={classes.root} onClose={onClose}>
      <Fade in={isOpened}>
        <div className={classes.paper}>
          {type === 'warning' && <WarningIcon className={classes.icon} style={{ fill: '#ff8393' }} />}
          {type === 'success' && <CheckCircleIcon className={classes.icon} style={{ fill: '#7ed321' }} />}
          {type === 'info' && <InfoIcon className={classes.icon} style={{ fill: '#81c5ff' }} />}
          {type === 'progress' && <CircularProgress size="30px" />}
          <span className={classes.title}>{title}</span>
          {children}
          <div className={classes.buttonsBlock}>
            {buttons &&
              buttons.map((button, index) => React.cloneElement(button, { key: `${type}-modal-button-${index}` }))}
          </div>
        </div>
      </Fade>
    </Modal>
  );
};

ActionStatusModal.propTypes = {
  children: PropTypes.node,
  isOpened: PropTypes.bool,
  type: PropTypes.oneOf(['info', 'warning', 'success', 'progress']),
  onClose: PropTypes.func.isRequired,
  title: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  buttons: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.element), PropTypes.instanceOf(null)]),
};

ActionStatusModal.defaultProps = {
  isOpened: false,
  type: 'info',
  buttons: null,
  title: '',
};

export default ActionStatusModal;
